/* eslint-disable react/jsx-props-no-spreading */
import clsx from 'clsx';
import isEmpty from 'lodash/isEmpty';
import React from 'react';

import { DeleteButton } from '@molecules';

import Typography from '../Typography';

import s from './styles.module.less';

const ArrayList = ({ as: List = 'ul', children, className, ...props }) => {
  const hasContent = !isEmpty(children);
  return (
    <List className={clsx(className, s.list, { [s.placeholder]: !hasContent })} {...props}>
      {(hasContent && children) || (
        <>
          <Typography.Title level={3}>Oops!</Typography.Title>
          <Typography.Text>
            <div>There&apos;s nothing to see here yet.</div>
            <div>Get started using the options above.</div>
          </Typography.Text>
        </>
      )}
    </List>
  );
};

const ArrayListItem = ({ as: Component = 'li', className, children, onDelete, onClick, ...props }) => (
  <Component className={clsx(s.item, className)} {...props}>
    <div className={s.wrapper}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div role="link" onClick={onClick} tabIndex={-1} className={clsx(s.itemInner, onClick && s.clickable)}>
        {children}
      </div>
      {onDelete && (
        <div style={{ padding: '0 15px' }}>
          <DeleteButton onDelete={onDelete} />
        </div>
      )}
    </div>
  </Component>
);

ArrayList.Item = ArrayListItem;

export default ArrayList;
